import React, { useCallback, useState, useRef } from "react";
import MaterialReactTable from "material-react-table";
import { useDispatch } from "react-redux";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import { getListReclamation, deleteReclamation, envoyerReclamationToAfc } from "../../Redux/reclamationReduce";
import jwt_decode from "jwt-decode";
import { toast, ToastContainer } from "react-toastify";
import SweetAlert from "react-bootstrap-sweetalert";
import { useHistory } from "react-router-dom";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";

function ListReclamation({ client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  const saveTableCalled = useRef(false);
  var token = localStorage.getItem("x-access-token");
  var annee = localStorage.getItem("annee");
  localStorage.removeItem("bonification");
  var decoded = jwt_decode(token);
  var idUser = decoded.id;
  const [loader, setLoader] = useState(true);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  const [alert, setAlert] = useState(null);
  const commentaireRef = useRef(null);

  // For commentaire
  const setCommentaire = (newValue) => {
    commentaireRef.current = newValue;
  };

  const idRole = useRef(0);

  const setIdRole = (newValue) => {
    idRole.current = newValue;
  };

  const confirmMessageAccept = (idClaim) => {
    setAlert(
      <SweetAlert
        title=""
        style={{ display: "block", marginTop: "-100px" }}
        success
        onConfirm={() => changeEtat(idClaim, loader)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
        <h3 className="alert-title">{t("valider_claim")}</h3>
        {t("valider_claim_msg")}?
      </SweetAlert>
    );
  };

  const changeEtat = useCallback(async (ids, client) => {
    hideAlert();
    if (saveTableCalled.current) return;
    saveTableCalled.current = true
    var etat = idRole.current == 5 ? 2 : 1;
    setLoader(true)
    dispatch(envoyerReclamationToAfc({ ids, commentaire: commentaireRef.current, client })).then(
      (e1) => {
        if (e1.payload === true) {
          setLoader(false)
          saveTableCalled.current = true
          fectchListReclamation(idUser, client)
          notify(1, t("add_txt"));
        } else {
          setLoader(false)
          saveTableCalled.current = false
          notify(2, t("erreur"));
        }
      }
    );
  }, []);

  const renderContentByStatus = (status) => {
    switch (status) {
      case 1:
        return t("Plainte_ouverte");
      case 0:
        return t("Plainte_ouverte");
      case 2:
        return t("Plainte_fermee");
      default:
        return null;
    }
  };

  const handleCheckboxChange = useCallback((event, id, ids, cell) => {
    if (event.target.checked === true) {
      cell.checked = true;
    } else {
      cell.checked = false;
    }
    setIds((prevIds) => {
      if (prevIds.includes(id)) {
        return prevIds.filter((prevId) => prevId !== id);
      } else {
        return [...prevIds, id];
      }
    });
  }, []);


  const [columns] = useState([
    {
      id: "check",
      header: "",
      accessorKey: "",
      Cell: ({ cell }) => (
        <label className="checkbox-container">
          <input
            type="checkbox"
            checked={cell.row.original.checked}
            onChange={(event) => handleCheckboxChange(event, cell.row.original.id, ids, cell.row.original)}
          /><span className="checkmark"></span></label>
      ),
    },
    // idRole.current !== 6
    //   ? {
    //     id: "grossiste",
    //     header: t("Wholesaler"),
    //     accessorKey: "grossistes.Raison_sociale",
    //   }
    //   : null,

    {
      id: "motif",
      header: 'Motif',
      accessorKey: "motif_description",
    }
    ,
    {
      id: "date",
      header: t("date_claim"),
      accessorKey: "createdAt",
      Cell: ({ cell }) => (
        <div className="block_action">
          {cell.row.original.createdAt !== null
            ? new Date(cell.row.original.createdAt)
              .toISOString()
              .slice(0, 10)
            : ""}
        </div>
      ),
    },
    {
      id: "status",
      header: t("status"),
      accessorKey: "status",
      Cell: ({ cell }) => (
        <div className="block_action">
          {renderContentByStatus(cell.row.original.status)}
        </div>
      ),
    },

    {
      id: "details",
      header: t("details"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <Button
          id={"idLigne_" + cell.row.original.id}
          onClick={(e) => {
            detailsReclamation(cell.row.original.id);
          }}
          className="btn-info btn"
          title={t("details")}
        >
          <i className="fa fa-eye" />
        </Button>
      ),
    },
    {
      id: "action",
      header: "Action",
      accessorKey: "",
      Cell: ({ cell }) => (
        (cell.row.original.status == 0 && idRole.current == 6) ?
          <div className="btn-cells">
            <Button
              id={"idLigne_" + cell.row.id}
              onClick={(e) => {
                editReclamation(cell.row.original.id);
              }}
              variant="warning"
              className="btn-warning btn mr-1"
              title="Modifier"
            >
              <i className="fa fa-edit" />
            </Button>
            {(cell.row.original.status == 0 && idRole.current == 6) ?
              <Button
                id={"idLigne_" + cell.row.id}
                onClick={(e) => {
                  confirmMessageDelete(cell.row.original.id);
                }}
                title="Supprimer"
                variant="danger"
                className="btn-danger btn"
              >
                <i className="fa fa-trash" />
              </Button> : null}

          </div> : null
      ),
    },

  ]);

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }
  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      setIdRole(response.payload.id_role)
    }
  }, [dispatch]);


  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  const deleteReclamationA = useCallback(
    async (id) => {
      dispatch(
        deleteReclamation(id)
      ).then(e => {
        hideAlert()
        fectchListReclamation(idUser)
        notify(1, t("supprimer_succes"));
      })
    },
    [dispatch]
  );

  const confirmMessageDelete = (id, nb) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={t("Reclamation.supprimer")}
        onConfirm={() => deleteReclamationA(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t("yes")}
        cancelBtnText={t("no")}
        showCancel
      >
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const fectchListReclamation = useCallback(
    async (idUser) => {
      var etat = idRole.current == 5 ? [1] : [0];
      var list = await dispatch(
        getListReclamation({
          id_user: idUser,
          etat, annee, client
        })
      );
      var res = list.payload.map(reclamation => ({
        ...reclamation,
        checked: false
      }));

      setLoader(false);
      setData(res);
    },
    [dispatch]
  );


  function detailsReclamation(id) {
    navigate.push(client + "/detailsReclamation/" + id);
  }

  function editReclamation(idReclamation) {
    navigate.push(client + "/updateReclamation/" + idReclamation);
  }

  const envoyer = useCallback((events) => {
    var verif = false
    verif = data.some(function (value) {
      return value.checked == true;
    });

    if (data.length > 0 && verif)
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title=""
          onConfirm={() => changeEtat(ids, client)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("valider")}
          cancelBtnText={t("annuler")}
          showCancel
        >
          <h3 className="alert-title">{t("valider_claim")}</h3>
          <div>
            <Col md="12" className="pr-1">
              <Form.Group>
                <label>{t('commentaire')} </label>
                <Form.Control
                  as={"textarea"}
                  className="form-control"
                  placeholder={t('write_comment')}
                  onChange={(e) => setCommentaire(e.target.value)}
                  rows="5"
                ></Form.Control>
              </Form.Group>
            </Col>
          </div>
        </SweetAlert>
      );
    else {
      notify(2, t("erreur"));
    }
  }, [t]);

  function send() {
    navigate.push(client + "/ajouterReclamation");
  }
  function ajouter() {
    navigate.push(client + '/ajouterReclamation');
  }
  React.useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idRole.current > 0) {
        fectchListReclamation(idUser, client);
      }
    };

    fetchData();
  }, [idRole.current]);

  return (
    <>
      {alert}
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn mr-1 float-left"
              type="button"
              variant="info"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              {t("Reclamation.add")}
            </Button>
          </Col>
        </Row>
        <Row>

          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">{t("claim_pending")}</Card.Title>
                <br clear="all"></br>
              </Card.Header>
              <Card.Body className="table-style">
                <Col md="8">
                  <Button
                    className="btn-wd  mr-1 float-left btn-info "
                    type="button"
                    onClick={envoyer}
                  >
                    <span className="btn-label">
                      <i className="far fa-paper-plane"></i>  {t("envoyer")}
                    </span>

                  </Button>
                </Col>
                <ListTable list={data} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListReclamation;
